import Notifications from '@kyvg/vue3-notification';
import { createApp } from 'vue';

import { setupIcons } from '@silae/composables';
import { ICON_LIBRARY, i18n, setupAuth, setupLogger, setupVeeValidate, vuetify } from '~/plugins';
import { importRoutes, routerFactory } from '~/router';
import { pinia } from '~/stores';

import App from './App.vue';
import './style';

(async () => {
	const routes = await importRoutes();
	//@ts-ignore
	const app = createApp(App);
	app.use(vuetify);
	app.use(pinia);
	app.use(routerFactory(routes));
	app.use(i18n);
	app.use(Notifications);

	setupAuth();
	// setupFontAwesome(app);
	setupIcons(app, ICON_LIBRARY);
	setupVeeValidate();
	setupLogger();

	app.mount('#app');
})();
